import { actionTypes } from "./ChurchVideoActions";

const initialState = {
  loading: false,
  churchVideos: [],
  error: null,
  success: false,
};

export default function churchVideoReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.SAVE_CHURCH_VIDEO_REQUEST:
    case actionTypes.UPDATE_CHURCH_VIDEO_REQUEST:
    case actionTypes.DELETE_CHURCH_VIDEO_REQUEST:
    case actionTypes.READ_CHURCH_VIDEO_REQUEST:
      return { ...state, loading: true, success: false, error: null };

    case actionTypes.SAVE_CHURCH_VIDEO_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        churchVideos: [...state.churchVideos, action.payload],
      };

    case actionTypes.UPDATE_CHURCH_VIDEO_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        churchVideos: state.churchVideos.map((item) =>
          item._id === action.payload._id ? action.payload : item
        ),
      };

    case actionTypes.DELETE_CHURCH_VIDEO_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        churchVideos: state.churchVideos.filter(
          (item) => item._id !== action.payload._id
        ),
      };

    case actionTypes.READ_CHURCH_VIDEO_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        churchVideos: action.payload,
      };

    case actionTypes.SAVE_CHURCH_VIDEO_FAILURE:
    case actionTypes.UPDATE_CHURCH_VIDEO_FAILURE:
    case actionTypes.DELETE_CHURCH_VIDEO_FAILURE:
    case actionTypes.READ_CHURCH_VIDEO_FAILURE:
      return { ...state, loading: false, success: false, error: action.payload };

    default:
      return state;
  }
}
